@if(editMode) {
<div class="edit-wrapper">
  <input
    #competencyTitleInput
    placeholder="Enter Competency Name"
    class="form-control competency-input"
    id="title"
    name="title"
    [(ngModel)]="updatedTitle"
    required />
  <div class="action-buttons">
    <div (click)="saveTitle()" class="btn-action">
      @if(saving) {
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      } @else {
      <i class="bi bi-check"></i>
      }
    </div>
    <div (click)="toggleEditMode()" class="btn-action">
      <i class="bi bi-x"></i>
    </div>
  </div>
</div>
} @else {
<div (click)="toggleEditMode()" class="preview-wrapper">
  {{ title }}
</div>
}
